import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    '&:not(:last-child)': {
      marginBottom: '0.5rem'
    }
  },

  contentArea: {
    position: 'relative',
    display: 'flex',
    border: '1px solid #f0f0f0',
    borderRadius: '100rem',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    maxHeight: '61px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F6F7F8',
      '& > button': {
        visibility: 'visible'
      }
    },
    '& > button': {
      visibility: 'hidden'
    }
  },

  content: {
    // Targets parent container of title & last message
    '& .Content-contentBlock': {
      flex: '1'
    },

    // Targets title and last message divs
    '& .Content-name, & .Content-content': {
      width: '100%',

      [theme.breakpoints.up(1280)]: {
        maxWidth: '20vw'
      },

      [theme.breakpoints.down(1279)]: {
        maxWidth: '70vw'
      },

      [theme.breakpoints.down(800)]: {
        maxWidth: '43vw'
      },

      [theme.breakpoints.down(500)]: {
        marginLeft: '1rem',
        maxWidth: 'calc(53vw - 1rem)'
      },

      [theme.breakpoints.down(400)]: {
        marginLeft: '1rem',
        maxWidth: 'calc(41vw - 1rem)'
      }
    },

    '& .Content-time, & .Content-controlsBlock': {
      [theme.breakpoints.down(600)]: {
        display: 'none'
      }
    }
  },

  button: {
    alignSelf: 'center',
    marginLeft: '1rem',
    marginRight: '1rem',
    height: 'fit-content',
    padding: '0.25rem 0.125rem',
    whiteSpace: 'nowrap'
  }
}))

export default useStyles
